module.exports = __webpack_public_path__ + "static/media/linje.8db18207.mp3";